import { getHttpClient } from '../../../../shared/utils/http-client.ts';
import { GroupParagraph } from '../models/group-paragraph';
import { updateGroupParagraphEndpoint } from './const';

export const updateGroupParagraph = (groupParagraph: GroupParagraph) => {
    return getHttpClient().post({ url: updateGroupParagraphEndpoint, data: JSON.stringify(groupParagraph) });
};
